import apiClient from './api'

export interface DashboardTrendPoint {
  timestamp: string
  label: string
  deposits: number
  withdrawals: number
}

export interface DashboardChannelStat {
  channel: string
  total: number
  average: number
  share: number
}

export interface DashboardAlert {
  type: 'info' | 'warning' | 'error' | 'success'
  message: string
}

export interface DashboardTransaction {
  id: string
  type: 'deposit' | 'withdrawal'
  msisdn: string
  amount: number
  paybill: string | null
}

export interface DashboardSummary {
  timeframe: {
    start: string
    end: string
    hours: number
  }
  totals: {
    deposits: number
    withdrawals: number
    net: number
    transactions: number
    activeUsers: number
  }
  trend: DashboardTrendPoint[]
  channels: DashboardChannelStat[]
  processing: {
    average: number
    median: number
    p95: number
    p99: number
  }
  recentTransactions: DashboardTransaction[]
  alerts: DashboardAlert[]
  successRate: {
    current: number
    previous: number
    change: number
  }
  statusDistribution: Array<{
    status: string
    count: number
    percentage: number
  }>
  failureAnalysis: {
    totalFailed: number
    byChannel: Array<{
      channel: string
      count: number
      percentage: number
    }>
    byPaybill: Array<{
      paybill: string
      count: number
    }>
  }
  transactionVelocity: {
    current: number
    peak: number
    peakTime: string | null
    data: Array<{
      timestamp: string
      label: string
      count: number
    }>
  }
  paybillPerformance: Array<{
    paybill: string
    volume: number
    count: number
    share: number
  }>
  averageTransactionSize: {
    deposits: number
    withdrawals: number
    overall: number
    depositsChange: number
    withdrawalsChange: number
  }
  peakHours: {
    data: Array<{
      hour: number
      label: string
      count: number
    }>
    peakHour: string | null
    peakCount: number
  }
}

export interface TopTransaction {
  id: string
  msisdn: string
  amount: number
  paybill: string | null
  createdAt: string | null
}

export interface TopTransactionsResponse {
  withdrawals: TopTransaction[]
  deposits: TopTransaction[]
  timeframe: {
    start: string
    end: string
    hours: number
  }
}

export interface FailureReasonItem {
  source: string
  reason: string
  count: number
}

export const dashboardService = {
  fetchSummary: (hours = 24): Promise<DashboardSummary> =>
    apiClient.get('/reports/dashboard-summary', { params: { hours } }).then((res) => res.data),
  fetchTopTransactions12h: (): Promise<TopTransactionsResponse> =>
    apiClient.get('/reports/top-transactions-12h').then((res) => res.data),
  fetchFailureReasons: (start: string, end: string, limit = 5): Promise<{ items: FailureReasonItem[] }> =>
    apiClient.get('/reports/failure-reasons', { params: { start, end, limit } }).then((res) => res.data),
}


